<template>
    <div
        class="mailing_preview"
    >
        <loading class="preview_loading"  v-if="!isLoading"/>
        <div
            v-else
            class="mailing_preview_wrapper"
        >
            <div v-if="this.previewData[0] && Object.keys(this.previewData[0]).length > 0"
                :class="gridClass()"
            >
                <div class="mailing_column_header_preview" v-for="(header, indexItem) in headers" :key="`${header.key}-a`">
                    {{ header.description }}
                </div>
                <template v-for="(item, index) in previewData">
                    <div class="mailing_column_preview" v-for="(header, indexItemV) in headers" :key="`${header.key}-v-${index}`">
                        {{ item[header.fieldsName] }}
                    </div>
                </template>
            </div>
            <div class="mailing_preview_title" v-else>
                Предпросмотр:
                <br />
                Фильтр по полям: не выбран.
            </div>
        </div>
    </div>
</template>

<script>
import { sortedByFieldsNoTyres } from "@/entities/Mailing/config/mailing.js";
import {useMailingStore} from "@/stores/MailingStore";
import { generateUniqueId } from '@/utils/generateUniqueId.js'
import loading from "@/components/support/loading";
import axios from "axios";

export default {
    name: "MailingPreview",
    components: {
        loading,
    },
    mounted() {
        this.getPreview();
    },
    setup() {
        const mailingStore = useMailingStore();

        return {
            mailingStore
        }
    },
    computed: {
        headers() {
            return this.mailingStore.filterByFields
                .filter(field => Object.keys(this.previewData[0]).includes(field.fieldsName))
                .map(field => ({ fieldsName: field.fieldsName, description: field.description, key: this.getUniqueKey() }));
            }
    },
    created() {
        this.$watch(() => [
            this.mailingStore.selectedFormats,
            //this.mailingStore.selectedStorageCities,  Дубль с checked.field
            this.mailingStore.selectedProducts,
            this.mailingStore.sortOrder,
            this.mailingStore.filterByFields,
            this.mailingStore.checked.field,
            this.mailingStore.sortedByFields,
            this.mailingStore.checked.sortedField
        ], () => {
            this.getPreview();
        }, { deep: true });
    },
    data: function () {
        return {
            previewData: [],
            isLoading: true,
            classNameGrid: ''
        };
    },
    methods: {
        getPreview() {
                this.isLoading = false;

                const selectedBySortedField = this.mailingStore.selectedProducts.length === 1
                    && this.mailingStore.selectedProducts.includes('tyres') ?
                            this.mailingStore.sortedByFields.filter(field =>
                                this.mailingStore.checked.sortedField.some(checkedField => checkedField.id === field.id))
                        :
                            sortedByFieldsNoTyres.filter(field =>
                                this.mailingStore.checked.sortedField.some(checkedField => checkedField.id === field.id));

                const data = {
                    selectedFormats: this.mailingStore.selectedFormats,
                    selectedStorageCities: this.mailingStore.selectedStorageCities,
                    selectedProducts: this.mailingStore.selectedProducts,
                    sortOrder: this.mailingStore.sortOrder,
                    selectedByField: this.mailingStore.filterByFields.filter(field =>
                        this.mailingStore.checked.field.some(checkedField => checkedField.id === field.id)),
                    selectedBySortedField: selectedBySortedField,
                };

                axios.post('/api/b2b_user/subscribe/create_view', data)
                    .then((response) => {
                        let resp = response.data;
                        if (typeof (resp.success) !== "undefined" && (resp.success === true)) {
                            this.previewData = resp.items;
                            this.isLoading = true;
                        }

                        if (typeof (resp.error) !== "undefined" && (resp.error === true)) {
                            this.$notifyError(resp.error);
                            this.isLoading = false;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$notifyError('Неизвестная ошибка, попробуйте вновь или обратитесь к менеджеру');
                        this.isLoading = false;
                    });
        },
        gridClass() {
            const columnCount = Object.keys(this.previewData[0]).length;
            return `grid grid-cols-${columnCount}`;
        },
        getUniqueKey() {
            return generateUniqueId();
        }
    }
}
</script>

<style scoped>
.mailing_preview {
    display: flex;
    flex-shrink: 0;
    width: 700px;
    height: 850px;
    overflow: hidden;
    box-sizing: border-box;
    border: 4px solid rgb(23, 74, 139);
}

.mailing_preview_wrapper {
    display: flex;
    width: 100%;
    overflow: scroll;
}

.grid {
  display: grid;
  width: 100%;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, 1fr);
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

.grid-cols-5 {
  grid-template-columns: repeat(5, 1fr);
}

.grid-cols-6 {
  grid-template-columns: repeat(6, 1fr);
}

.grid-cols-7 {
    grid-template-columns: repeat(7, 1fr);
}

.grid-cols-8 {
    grid-template-columns: repeat(8, 1fr);
}

.grid-cols-9 {
    grid-template-columns: repeat(9, 1fr);
}

.grid-cols-10 {
    grid-template-columns: repeat(10, 1fr);
}

.preview_loading {
    margin-top: 50px;
}

.mailing_column_preview {
    display: flex;
    gap: 3px;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 10px 5px;
    border-bottom: 1px dashed rgb(161, 161, 161);
    box-sizing: border-box;
    height: auto;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
}

.mailing_column_header_preview {
    display: flex;
    width: 100%;
    padding: 10px;
    align-items: center;
    justify-content: center;
    color: rgb(26, 55, 81);
    font-size: 16px;
    font-weight: 600;
    line-height: 17px;
    border-bottom: 4px solid #174A8B;
    box-sizing: border-box;
    text-align: center;
}

.mailing_preview_title {
    width: 100%;
    margin-top: 50px;
    text-align: center;
    font-size: 42px;
    font-weight: 500;
    line-height: 60px;
    color: rgb(23, 74, 139);
}

@media (max-width: 1500px) {
    div.mailing_preview {
        width: 100%;
        height: 350px;
        flex-shrink: 1;
        margin-right: 20px;
    }
}
</style>

import { stringify } from "to";

